const angularRoutes = [
  '#/auctions',
  '#/secondary-trading',
  '#/secondary-overview',
  '#/network-point',
  '#/create-proposal',
  '#/edit-proposal',
  '#/create-external-trade',
];

export const isTransportActive = (pathname: string, hash: string) =>
  pathname.startsWith('/transport') ||
  pathname.startsWith('/snam-bidding') ||
  pathname.startsWith('/modulation-service-auctions') ||
  (pathname.startsWith('/platform') &&
    angularRoutes.some((angularRoute) => hash.startsWith(angularRoute)));
